module.exports = __webpack_public_path__ + "img/12.65df756c.jpg";